export default "__VITE_ASSET__DxJej10w__"